import {
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';

import getMoreNewsOnPageAPI from '../../api/get-more-news-on-page';
import { INewOnPageResponse, INewOnPageResponseArray } from '../../utils/types/admin-types';
import {
  rejectGetMoreNews,
  requestGetMoreNews,
  reсeiveGetMoreNews,
} from '../actions/main-page';

interface IGetNews {
  type: string;
  payload: {
    nextPage: string;
  }
}

interface INewOnPagResponses {
  results: INewOnPageResponseArray[];
  news: INewOnPageResponse;
}

const getMoreNews = function* getMoreNews(action: IGetNews) {
  try {
    const response: INewOnPagResponses = yield call(getMoreNewsOnPageAPI, action.payload.nextPage);
    const news: INewOnPagResponses = yield select(
      (state) => state.newsReducer.responses,
    );
    const newArr = {
      ...response,
      results: [...news.results, ...response.results],
    };
    yield put(reсeiveGetMoreNews({ news: newArr }));
  } catch (error) {
    yield put(rejectGetMoreNews({ error }));
  }
};

export default function* getMoreNewsWatcher() {
  yield takeLatest(requestGetMoreNews, getMoreNews);
}
